function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.352 0l7.352 10-1.715-.02-5.652-7.652L1.715 9.98H0L7.352 0z",
  fill: "currentColor"
});

var SvgArrowUp = function SvgArrowUp(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='15' height='10' viewBox='0 0 15 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M7.35179 0L14.7036 10L12.9887 9.97949L7.33688 2.32821L1.71492 9.97949H0L7.35179 0Z' fill='currentColor'/%3E %3C/svg%3E";
export { SvgArrowUp as ReactComponent };